export default "__VITE_ASSET__Cs8L5Zzk__"